import { defineAsyncComponent } from "vue";

export default {
    sectionContainer: defineAsyncComponent(() => import("./SectionContainer.vue")),
    webButton: defineAsyncComponent(() => import("./WebButton.vue")),
    heroContent: defineAsyncComponent(() => import("./HeroContent.vue")),
    card: defineAsyncComponent(() => import("./Card.vue")),
    // Default hero shell (full-bleed background + scroll-pin effect) — the
    // existing shared component, unmoved. Themes that just want different
    // hero *content* styling override heroContent instead of this. Themes
    // that need a structurally different hero (e.g. always-boxed) override
    // this slot directly with their own self-contained component.
    hero: defineAsyncComponent(() => import("@/components/HeroSection.vue")),
    tokens: {
        // Default heading/body/muted text tiers — match the Tailwind
        // gray-900/700/600 values every shared section component used to
        // hardcode directly. Themes with dark card surfaces (neon, noir)
        // override these; everything else inherits them unchanged.
        "--theme-text-heading": "#111827",
        "--theme-text-body": "#374151",
        "--theme-text-muted": "#4b5563",
    },
};
